<template>
	<div :id="id" class="c-search-section-documents">
		<div
			:class="[
				'grid gap-layout-gutter',
				'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
			]"
		>
			<ContentCard
				v-for="(item, index) in items"
				:key="`item-${index}`"
				:title="item.name"
				:download="item.name"
				:link="{ url: item.url, target: '_blank' }"
			>
				<template #after>
					<div class="flex items-center space-x-12 mt-lg">
						<div
							:class="[
								'flex items-center justify-center',
								'w-24 h-24 rounded-full bg-black text-white',
							]"
						>
							<SvgDownload class="w-12" />
						</div>

						<span
							:class="[
								'font-bold font-darker-grotesque',
								'uppercase text-button-xs',
							]"
							v-text="'Download'"
						></span>
					</div>
				</template>
			</ContentCard>
		</div>
	</div>
</template>

<script>
import SvgDownload from '~/assets/svgs/icon-download.svg?inline';
import ContentCard from '~/components/shared/ContentCard';

export default {
	name: 'SearchSectionDocuments',
	components: { SvgDownload, ContentCard },

	props: {
		id: {
			type: String,
			required: true,
		},

		items: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
